import { create } from "zustand";
import { persist } from "zustand/middleware";

const useFilterStore = create(
	persist(
		(set) => ({
			filter: {
				estate_parent_id: "",
				estate_id: "",
				type_currency: "USD",
				search: "",
				application: "",
				parameter: "",
				unit_measurement: "kg_l",
			},

			setFilter: (newFilter) => set({ filter: newFilter }),

			updateFilter: (updates) => set((state) => ({ filter: { ...state.filter, ...updates } })),

			resetFilter: () =>
				set({
					filter: {
						estate_parent_id: "",
						estate_id: "",
						type_currency: "USD",
						search: "",
						application: "",
						parameter: "",
						unit_measurement: "kg_l",
					},
				}),
		}),
		{
			name: "agroinventario-filter-storage",
		},
	),
);

export default useFilterStore;
